import { Controller } from "@hotwired/stimulus"

// Автокомплит для раздела «Доступная среда».
// Режим tree (страница каталога): фильтрует категории и товары в них.
// Режим flat (страница категории): фильтрует только товары.
export default class extends Controller {
  static targets = ["input", "panel", "clear", "empty", "category", "product"]
  static values = { mode: { type: String, default: "tree" } }

  connect() {
    this.onDocClick = this.handleDocClick.bind(this)
    document.addEventListener("click", this.onDocClick)
    this.applyFilter("")
  }

  disconnect() {
    document.removeEventListener("click", this.onDocClick)
  }

  open() {
    this.element.classList.add("is-open")
  }

  close() {
    this.element.classList.remove("is-open")
  }

  handleDocClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  filter() {
    const q = this.inputTarget.value.trim().toLowerCase()
    this.applyFilter(q)
    if (this.hasClearTarget) this.clearTarget.hidden = q.length === 0
    if (q.length > 0) this.open()
  }

  clear(event) {
    event?.preventDefault()
    this.inputTarget.value = ""
    this.inputTarget.focus()
    this.filter()
  }

  toggleCategory(event) {
    event.preventDefault()
    event.stopPropagation()
    const button = event.currentTarget
    const cat = button.closest("[data-accessibility-search-target='category']")
    if (!cat) return
    const expanded = cat.classList.toggle("is-expanded")
    button.setAttribute("aria-expanded", expanded ? "true" : "false")
  }

  applyFilter(q) {
    this.element.classList.toggle("has-query", q.length > 0)

    if (this.modeValue === "flat") {
      this.filterFlat(q)
    } else {
      this.filterTree(q)
    }
  }

  filterFlat(q) {
    let shown = 0
    this.productTargets.forEach((el) => {
      const match = q === "" || (el.dataset.searchText || "").includes(q)
      el.hidden = !match
      if (match) shown++
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = shown > 0
  }

  filterTree(q) {
    let totalShown = 0

    this.categoryTargets.forEach((catEl) => {
      const catText = catEl.dataset.searchText || ""
      const catMatches = q === "" || catText.includes(q)

      const products = catEl.querySelectorAll("[data-accessibility-search-target='product']")
      let productMatches = 0
      products.forEach((p) => {
        const text = p.dataset.searchText || ""
        const match = q === "" || catMatches || text.includes(q)
        p.hidden = !match
        if (match) productMatches++
      })

      const showCategory = q === "" || catMatches || productMatches > 0
      catEl.hidden = !showCategory
      if (showCategory) totalShown++

      // При активном поиске авто-разворачиваем категории с совпадениями,
      // при сбросе запроса возвращаем дефолт (свёрнуто).
      const toggle = catEl.querySelector(".acc-search-cat-toggle")
      if (q === "") {
        catEl.classList.remove("is-expanded")
        if (toggle) toggle.setAttribute("aria-expanded", "false")
      } else if (showCategory && productMatches > 0) {
        catEl.classList.add("is-expanded")
        if (toggle) toggle.setAttribute("aria-expanded", "true")
      }
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = totalShown > 0
  }
}
